import React from 'react';
import Chart from "react-apexcharts";
import global from '../../../common/utility/global';

export default function GraficoCantidadComprobante(props) {
    
    const options = {
      series: [{
        name: "Cantidad Comprobantes",
        data: props.series
      }],
      title: {
        text: 'Cliente Ranking -  Cantidad de Comprobantes',
        align: 'center',
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          fontFamily: undefined,
          color: "#263238",
        },
      },
      chart: {
        type: 'bar',
        height: 350,
        zoom: {
          enabled: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: true,
        }
      },
      dataLabels: {
          formatter: function (val) {
            return global.decimalFormat(parseInt(val.toFixed(2)))
          }
      },
      xaxis: {
        categories: props.clientes,
        labels: {
          formatter: function (val) {
            return global.decimalFormat(parseInt(val.toFixed(2)))
          }
        }
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return global.decimalFormat(parseInt(val.toFixed(2)))
          }
        }
      }
    };
    return (
      <div id="chart">
        <Chart options={options} series={options.series} type="bar" height={350} />
      </div>
    );
}